import { useState, useEffect } from 'react';

export function useAppVersion() {
  const [version, setVersion] = useState<string>('1.0.0');

  useEffect(() => {
    // Fonction pour extraire la version du service worker
    const getVersionFromSW = async () => {
      try {
        // Vérifier si le service worker est enregistré
        if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
          // Créer un canal de communication
          const messageChannel = new MessageChannel();
          
          // Définir ce qui se passe quand on reçoit une réponse
          messageChannel.port1.onmessage = (event) => {
            if (event.data && event.data.type === 'VERSION_RESPONSE') {
              setVersion(event.data.version);
            }
          };

          // Envoyer un message au service worker pour demander la version
          navigator.serviceWorker.controller.postMessage({
            type: 'GET_VERSION'
          }, [messageChannel.port2]);
        } else {
          // Récupérer la version depuis le cache si le service worker n'est pas disponible
          try {
            const cache = await caches.open('pokemon-tcg-pocket-version');
            const versionResponse = await cache.match('version');
            if (versionResponse) {
              const versionText = await versionResponse.text();
              setVersion(versionText);
            }
          } catch (error) {
            console.error('Erreur lors de la récupération de la version depuis le cache:', error);
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération de la version:', error);
      }
    };

    getVersionFromSW();
  }, []);

  return version;
} 